import fs from 'node:fs'
import type { SchemaOwnershipIndex } from '@cli-types/preset-engine/presets.js'
import { ownershipPath } from './ownership-path.js'

export function loadSchemaOwnershipIndex(cwd: string): SchemaOwnershipIndex {
  const filePath = ownershipPath(cwd)
  if (!fs.existsSync(filePath)) {
    return {
      version: 1,
      schemas: {}
    }
  }

  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as SchemaOwnershipIndex
}
